import React, { useState } from 'react';
import Constant from '@/common/constant/Constant';
import { Tooltip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const closeBtnStyle = {
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    width: '20px',
    height: '20px',
    backgroundColor: '#9e9e9e',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: 9999,
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    border: 'none',
    padding: 0,
};

export default function CollapseChatBox(props) {
    const {
        setIsShowChatBox,
        chatbotSettings,
        isNewUnReadMessage,
        POPUlAR_MOBILE_DEVICE_WIDTH,
        isIframeChatBot,
        deviceWidth
    } = props;

    const [isHidden, setIsHidden] = useState(false);

    const onClickOpenChatbot = () => {
        window.parent.postMessage(Constant.CHATBOT_ACTION.OPEN_CHATBOT, '*');
        setIsShowChatBox(true);
    };

    const onClickCloseChatbot = (e) => {
        e.stopPropagation();
        window.parent.postMessage(Constant.CHATBOT_ACTION.HIDE_CHATBOT, '*');
        setIsHidden(true);
    };

    if (isHidden) return null;

    return (
        <div
            className={`collapse-chatbox ${isNewUnReadMessage ? 'random-color-chatbox' : ''}`}
            onClick={() => onClickOpenChatbot()}
        >
            <div style={closeBtnStyle} onClick={onClickCloseChatbot}>
                <CloseIcon style={{ fontSize: 12, color: '#fff' }} />
            </div>

            <div className="chat-logo-hide">
                <img
                    src={
                        chatbotSettings?.headerIcon &&
                        chatbotSettings?.headerIcon !== Constant.SETTING_CHAT_BOT.LOGO_ICON_DEFAULT
                            ? chatbotSettings?.headerIcon
                            : Constant.SETTING_CHAT_BOT.LOGO_ICON_WHITE
                    }
                    alt="Logo"
                />
            </div>

            <div className="chat-title" onClick={() => onClickOpenChatbot()}>
                {' '}
                {isIframeChatBot && Number(deviceWidth) < Number(POPUlAR_MOBILE_DEVICE_WIDTH) ? (
                    <span>{chatbotSettings?.chatbotTextInHeader}</span>
                ) : Number(window.innerWidth) > Number(POPUlAR_MOBILE_DEVICE_WIDTH) ||
                  Number(window.outerWidth) > Number(POPUlAR_MOBILE_DEVICE_WIDTH) ? (
                    <Tooltip
                        title={chatbotSettings?.chatbotTextInHeader}
                        placement="top"
                        disableTouchListener={true}
                    >
                        <span>{chatbotSettings?.chatbotTextInHeader}</span>
                    </Tooltip>
                ) : (
                    <span>{chatbotSettings?.chatbotTextInHeader}</span>
                )}
            </div>
        </div>
    );
}
